import { createContext, use, type ReactNode } from "react";
import type { ClienteApi } from "./cliente";

const Contexto = createContext<ClienteApi | null>(null);

/** La app arma el cliente (con la sesión) y lo entrega aquí; las funcionalidades lo piden con useClienteApi. */
export function ProveedorApi({ cliente, children }: { cliente: ClienteApi; children: ReactNode }) {
  return <Contexto value={cliente}>{children}</Contexto>;
}

export function useClienteApi(): ClienteApi {
  const cliente = use(Contexto);
  if (!cliente) throw new Error("useClienteApi requiere ProveedorApi");
  return cliente;
}
